/**
 * Hand-written product detail content for catalog items that were never scraped
 * (spec-sheet driven SKUs). Merged into getProductDetails() ahead of the
 * auto-generated map.
 */

const A = (p) => `${process.env.REACT_APP_BACKEND_URL}/api/static/janitorial/${p}`;

export const JANITORIAL_MANUAL_DETAILS = {
  "TM-M-01402-BL": {
    title: '18" Blue Twist Face Microfiber Flat Mop — Velcro Back',
    images: [
      A("microfiber-addons/tm_m_01402_bl_face.png"),
      A("microfiber-addons/tm_m_01402_bl_back.png"),
    ],
    lead: [
      'A reusable 18" flat mop pad built for hospital environmental services: twist-face microfiber yarn for soil capture and chemical hold, a foam insert that spreads solution evenly across the pad, and a white hook-and-loop back that seats on standard 18" velcro flat-mop frames.',
      "Blue is the usual color-code for general patient-care areas — one charged pad per room, then straight to the laundry.",
    ],
    pdfs: [
      {
        label: "Product Specification Sheet (PDF)",
        file: `${process.env.REACT_APP_BACKEND_URL}/api/spec-sheets/tm-m-01402-bl.pdf`,
      },
    ],
    sections: [
      {
        heading: "Specifications",
        items: [
          "Item / specification number: TM-M-01402-BL",
          'Nominal size: 18 in. · Color: Blue',
          "Face construction: twist face microfiber yarn",
          "Fiber composition: 80 / 20 polyester / polyamide microfiber yarn",
          "Insert: foam insert for even solution release",
          "Backing: white velcro (hook-and-loop) back",
          'Frame compatibility: standard 18" hook-and-loop flat-mop frames',
          "Reusable and launderable",
        ],
      },
      {
        heading: "Packaging & ordering",
        items: [
          "Unit of measure: case (CS)",
          "Case quantity: 240 pads per case (240/CS)",
          "Minimum order: 1 case",
          "In stock — 3-day shipping included",
          "No additional tariffs or sales tax on this product",
        ],
      },
      {
        heading: "Where it is used",
        items: [
          "Patient rooms, corridors and discharge / terminal cleaning",
          "Color-coded programs — blue for general patient-care areas",
          "Pairs with 16–18 in. aluminum swivel frames and telescopic poles",
          "Charge in a bucket, press system or pre-soak tub; one pad per room",
        ],
      },
      {
        heading: "Laundering & care",
        items: [
          "Launder without fabric softener — softener blinds the microfiber split and kills pickup",
          "No chlorine bleach; low-residue detergent on a warm wash",
          "Dry on low heat or air dry; high heat glazes the fibers",
          "Wash microfiber separately from cotton to avoid lint transfer",
        ],
      },
    ],
  },
};
